import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Glyphicon, Panel, Radio } from 'react-bootstrap';
import './VideoPage.css';
import { logResult, nextVideo } from '../../redux/actions'
import { NUMBER_OF_VIDEOS, VIDEO_BASE_URL, AUDIO_ONLY, QUESTION } from "../../services/config";

class VideoPage extends Component {

    constructor(props) {
        super(props);
        this.state = { showForm: false, bothReady: false, vid1Ready: false, vid2Ready: false, isPlaying: false };
    }

    play = () => {
        //this.setState({ ...this.state, showForm: false });
        const video1 = this.videoElement1;
        const video2 = this.videoElement2;
        //video1.currentTime = 0;
        //video2.currentTime = 0;
        video1.play()
        video2.play()
        this.setState({ ...this.state, isPlaying: true })
    };

    pause = () => {
        const video1 = this.videoElement1;
        const video2 = this.videoElement2;
        video1.pause();
        video2.pause();
        this.setState({ ...this.state, isPlaying: false })
    }

    onPlayButtonPressed = () => {
        this.state.isPlaying ? this.pause() : this.play();
    }

    playSecond = () => {
        const video2 = this.videoElement2
        if (this.state.vid2Ready) {
            console.log("Playing 2")
            video2.play();
        }
    }
    playFirst = () => {
        const video1 = this.videoElement1
        if (this.state.vid2Ready) {
            console.log("Playing 1")
            video1.play()
        }
    }

    onVideoLoaded = (num) => {

        if (num === 1) {
            console.log("1 ready")
            this.setState({ ...this.state, vid1Ready: true })
        }
        if (num === 2) {
            console.log("2 ready")
            this.setState({ ...this.state, vid2Ready: true })
        }
        // if(this.state.vid1Ready && this.state.vid2Ready){
        //     this.play()
        // }
    }

    componentDidUpdate = (prevprops, prevstate) => {
        if ((prevstate.vid1Ready !== this.state.vid1Ready) || (prevstate.vid2Ready !== this.state.vid2Ready)) {
            console.log("should check if both are ready")
            if (this.state.vid1Ready && this.state.vid2Ready) {
                console.log("should play now")
            }
        }
    }

    componentDidMount = () => {
        console.log(this.props.videotest.get("device").screen.orientation)
        this.videoElement1.load()
        this.videoElement2.load()
    }

    getVid1Text = () => {
        if (AUDIO_ONLY) {
            return "Alternativ 1"
        } else {
            const orientation = this.props.videotest.get("device").screen.orientation
            if (orientation === "landscape") {
                return "Vänster"
            }
            else if (orientation === "portrait") {
                return "Övre"
            }
        }
    }

    getVid2Text = () => {
        if (AUDIO_ONLY) {
            return "Alternativ 2"
        } else {

            const orientation = this.props.videotest.get("device").screen.orientation
            if (orientation === "landscape") {
                return "Höger"
            }
            else if (orientation === "portrait") {
                return "Nedre"
            }
        }
    }

    nextPage = () => {
        this.props.nextVideo();
        this.videoElement1.load();
        this.videoElement2.load();
        this.setState({ ...this.state, vid1Ready: false, vid2Ready: false });
    };

    selectRadio = (e) => {
        let result = e.target.id.substr(5);
        this.props.logResult(result)
    };

    isChecked(number) {
        return this.getCurrentResult() === number;
    }

    getCurrentResult() {
        return this.props.videotest.getIn(['result', `${this.props.videotest.get('video1')}::${this.props.videotest.get('video2')}`]);
    }

    isNextEnabled() {
        return this.getCurrentResult() === undefined;
    }

    showForm = () => {
        this.setState({ showForm: true });
    };

    render() {

        //const showForm = this.state.showForm;

        const form = (<div id="control-container">
            <Panel id="control-panel">
                <Panel.Body>
                    <table className="quality-form">
                        <tbody>
                            <tr>
                                <td colSpan="3">
                                    <h4 style={{ width: "100%" }}>{QUESTION}?</h4>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <Glyphicon glyph="arrow-left" /> Vänster bild
                            </td>
                                <td>
                                </td>
                                <td>
                                    Höger bild <Glyphicon glyph="arrow-right" />
                                </td>
                            </tr> */}
                            <tr>
                                <td className="RadioLeft">
                                    <Radio id="Radio-1" name="radioGroup" onClick={this.selectRadio}
                                        checked={this.isChecked('-1')}>
                                        {this.getVid1Text()}
                                    </Radio>
                                </td>
                                <td>
                                    <Radio id="Radio0" name="radioGroup" onClick={this.selectRadio}
                                        checked={this.isChecked('0')}>
                                        Ingen skillnad
                                    </Radio>
                                </td>
                                <td className="RadioRight">
                                    <Radio id="Radio1" name="radioGroup" onClick={this.selectRadio}
                                        checked={this.isChecked('1')}>
                                        {this.getVid2Text()}
                                    </Radio>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    &nbsp;
                    <Button className="btn btn-primary"
                        onClick={this.nextPage}
                        disabled={this.isNextEnabled()}
                    >
                        Nästa <Glyphicon glyph="step-forward" />
                    </Button>
                </Panel.Body>
            </Panel>
        </div>);

        return (
            <div className="App">
                {!AUDIO_ONLY && (
                    <div className="video-container">
                        <video id="video1"
                            controls="100%"
                            className="video-player"
                            tabIndex={-1}
                            data-video-id={this.props.videotest.get('progress')}
                            ref={videoElement => (this.videoElement1 = videoElement)}
                            //onLoadedData={() => this.onVideoLoaded()}
                            //autoPlay
                            onCanPlayThrough={() => this.onVideoLoaded(1)}
                        //onEnded={() => this.playSecond()}
                        >
                            <source src={VIDEO_BASE_URL + this.props.videotest.get('video1') + ".mp4"} type="video/mp4; codecs=hvc1.2.4.L153" />
                        </video>
                        <video id="video2"
                            className="video-player"
                            controls="100%"
                            tabIndex={-1}
                            data-video-id={this.props.videotest.get('progress')}
                            ref={videoElement => (this.videoElement2 = videoElement)}
                            //onEnded={this.showForm}
                            onCanPlayThrough={() => this.onVideoLoaded(2)}
                        //autoPlay
                        >
                            <source src={VIDEO_BASE_URL + this.props.videotest.get('video2') + ".mp4"} type="video/mp4; codecs=hvc1.2.4.L153" />
                        </video>
                    </div>)}
                {AUDIO_ONLY && (
                    <div className="audio-container">
                        <figure>
                            <figcaption>Alternativ 1</figcaption>
                            <audio id="video1"
                                controls="100%"
                                className="audio-player"
                                tabIndex={-1}
                                data-video-id={this.props.videotest.get('progress')}
                                ref={videoElement => (this.videoElement1 = videoElement)}
                                //onLoadedData={() => this.onVideoLoaded()}
                                //autoPlay
                                onCanPlayThrough={() => this.onVideoLoaded(1)}
                                onEnded={() => this.playSecond()}
                            >
                                <source src={VIDEO_BASE_URL + this.props.videotest.get('video1') + ".wav"} type="audio/wav" />
                            </audio>
                        </figure>
                        <figure>
                            <figcaption>Alternativ 2</figcaption>
                            <audio id="video2"
                                className="audio-player"
                                controls="100%"
                                tabIndex={-1}
                                data-video-id={this.props.videotest.get('progress')}
                                ref={videoElement => (this.videoElement2 = videoElement)}
                                onEnded={this.showForm}
                                onCanPlayThrough={() => this.onVideoLoaded(2)}
                            //autoPlay
                            >
                                <source src={VIDEO_BASE_URL + this.props.videotest.get('video2') + ".wav"} type="audio/wav" />
                            </audio>
                        </figure>
                    </div>
                )}
                <div className="button-container" style={{ "marginLeft": "auto", "marginBottom":"0rem", height:"5rem" }}>
                    <button className='btn btn-primary' disabled={this.vid1Ready && this.vid2Ready} onClick={() => this.onPlayButtonPressed()} style={{"width": "60rem"}}>
                        {this.state.isPlaying ? (<Glyphicon glyph="pause" />) : (<Glyphicon glyph='play' />)}
                    </button>
                </div>
                {form}
                <div id="step-container">
                    <Panel id="step-panel">
                        <span className="progress-text">
                            Steg {this.props.videotest.get('progress')} av {NUMBER_OF_VIDEOS + 1}
                        </span>
                    </Panel>
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => ({
    videotest: state.get('videotest')
});

const mapDispatchToProps = dispatch => {
    return {
        nextVideo: () => dispatch(nextVideo()),
        logResult: (id) => dispatch(logResult(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoPage);



// WEBPACK FOOTER //
// ./src/components/VideoPage/VideoPage.js